import styled from 'styled-components'
import OutboundLink from '../../analytics/components/OutboundLink'


const StyledOutboundLink = styled(OutboundLink)`
    text-decoration: none;
    color: #2172BA;
`;

export default StyledOutboundLink;